import { useState } from "react";
import { Clock } from "react-feather";
import { Alerts, Btn, P } from "../../../../AbstractElements";

const LightOutline = () => {
  const [active, setActive] = useState(true);
  return (
    <Alerts color="default" isOpen={active} className={`txt-primary border-primary alert-dismissible fade`}>
      <Clock />
      <P>
        {"One of "}
        <strong> {"YouTube's"} </strong>
        {"most crucial ranking factors is Watch Time."}
      </P>
      <Btn color="transperant" close onClick={() => setActive(false)} />
    </Alerts>
  );
};
export default LightOutline;
